<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="invokeMethod($event)"
                                action="showPartsSpecType"
                                perm="configuration.update"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetPartsSpecTypes()"
                            ></bc-btn-refresh>
                            <bc-search-menu
                                :params="axiosParams"
                            >
                                <v-list>
                                    <v-list-tile class="mb-3">
                                        <bc-search-input
                                            v-model="filter.search"
                                            :params="axiosParams"
                                        ></bc-search-input>
                                    </v-list-tile>

                                    <v-divider></v-divider>

                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table
                        :headers="headers"
                        :items="parts_spec_types"
                        :no-data-text="$t('lang.no_results_matching')"
                        hide-actions
                        :class="{ 'prevent-click': !hasPerm('configuration.update') }"
                    >
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="showPartsSpecType(props.item)">
								<td>{{ props.item.spec_type }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination
                        :page="page"
                        :params="axiosParams"
                        name="settings_parts_spec_type"
                    ></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="parts_spec_type_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('spec_type_id') ? $t('lang.edit_parts_spec_type') : $t('lang.add_parts_spec_type') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closePartsSpecTypeDialog"
                            :dialog-status="parts_spec_type_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="parts_spec_type" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="parts_spec_type_dialog"
											v-model="parts_spec_type.spec_type"
											:label="`${$t('lang.spec_type')} *`"
											:counter="showCounter(parts_spec_type.spec_type, 'parts_spec_type.spec_type')"
											:rules="ifValid('parts_spec_type.spec_type')"
										></v-text-field>
									</v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="currObjField('spec_type_id') && hasPerm('configuration.delete')" color="error" @mouseup.left="$refs.delete_parts_spec_type.openDialog()">{{ $t('lang.delete') }}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closePartsSpecTypeDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success" @mouseup.left="modifyPartsSpecType(currObjField('spec_type_id') ? 'patch' : 'post', currObjField('spec_type_id'))">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_parts_spec_type"
                :heading="$t('lang.delete_parts_spec_type')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="modifyPartsSpecType('delete', currObjField('spec_type_id'))"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [{ text: this.$t("lang.spec_type"), sortable: false, width: "100%" }],
            parts_spec_type: {
                spec_type: "",
            },
            current_obj: null,
            filter: {
                search: "",
                page_size: 0,
                page_num: 0,
            },
            parts_spec_type_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showPartsSpecType", perms: ["configuration.create"] },
                { title: this.$t("lang.refresh"), action: "dbGetPartsSpecTypes" },
            ],
            dbGetPartsSpecTypes: _.debounce(this.getPartsSpecTypes, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchPart", {
                url: "parts_spec_types",
                method: "get",
                stateProperty: "parts_spec_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.parts_spec_types) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.$store
            .dispatch("fetchPart", {
                url: "parts_spec_types",
                method: "get",
                stateProperty: "parts_spec_types",
                commit: true,
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.parts_spec_types) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    computed: {
        ...mapState({
            rules_parts_spec_type: (state) => state.validation.rules_parts_spec_type,
            default_filter: (state) => state.parts.parts_spec_types_filter,
            page: (state) => state.parts.page,
            parts_spec_types: (state) => state.parts.parts_spec_types,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        closePartsSpecTypeDialog() {
            this.parts_spec_type_dialog = false;
            this.$refs.delete_parts_spec_type.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getPartsSpecTypes() {
            this.startLoader();
            this.$store
                .dispatch("fetchPart", {
                    url: "parts_spec_types",
                    method: "get",
                    stateProperty: "parts_spec_types",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.parts_spec_type_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyPartsSpecType(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("parts_spec_type")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchPart", {
                                pk: "spec_type_id",
                                id: id,
                                url: `parts_spec_types/${id ? id : ""}`,
                                method: method,
                                stateProperty: "parts_spec_types",
                                mutate: true,
                                body: this.parts_spec_type,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closePartsSpecTypeDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        showPartsSpecType(item = null) {
            this.current_obj = item;

            if (this.$refs.parts_spec_type) item ? this.$refs.parts_spec_type.resetValidation() : this.$refs.parts_spec_type.reset();

            this.$nextTick(() => {
                this.assignObj(this.parts_spec_type, item, this.rules_parts_spec_type);
                this.parts_spec_type_dialog = true;
            });
        },
    },
};
</script>
